import { formatSeconds } from '../../../../../utils/date';
import {
  LongSessionFailureCause,
  LongSessionStage,
  WorkoutPublishStatus,
} from '../../../../../utils/longSession';
import texts from './texts.json';

/**
 * Coarser than the builder's per-stage text on purpose: the table answers "can I assign this yet",
 * and a workout with nothing to show here is one that needs no explanation.
 */
const getStatusText = ({ publishStatus, videoProcessing }) => {
  if (publishStatus === WorkoutPublishStatus.FAILED) {
    return videoProcessing?.error?.cause === LongSessionFailureCause.CANCELLED
      ? texts.status.cancelled
      : texts.status.failed;
  }
  if (publishStatus !== WorkoutPublishStatus.PENDING) {
    return '';
  }
  return videoProcessing?.stage === LongSessionStage.UPLOADING
    ? texts.status.uploading
    : texts.status.processing;
};

const getColumns = ({
  actionsRenderCell,
  isAdmin,
  isLongSessionEnabled,
}) => {
  const columns = [
    {
      field: 'name',
      quickSearch: true,
      headerName: texts.columns.workoutName,
      flex: 30,
    },
    {
      field: 'estimatedDuration',
      headerName: texts.columns.duration,
      flex: 20,
      valueGetter: ({ row }) => (
        `${row.estimatedDuration ? formatSeconds(row.estimatedDuration)
          : texts.emptyCell
        }`
      ),
    },
    {
      field: 'actions',
      sortable: false,
      filterable: false,
      headerName: texts.columns.actions,
      flex: 20,
      renderCell: actionsRenderCell,
    },
  ];

  if (isLongSessionEnabled) {
    columns.splice(columns.length - 1, 0, {
      field: 'status',
      headerName: texts.columns.status,
      flex: 20,
      valueGetter: ({ row }) => getStatusText(row),
    });
  }

  if (isAdmin) {
    columns.splice(1, 0, {
      field: 'workoutId',
      headerName: texts.columns.workoutId,
      flex: 10,
      valueGetter: ({ row }) => row.id || texts.emptyCell,
    });
  }

  return columns;
};

export default getColumns;
